import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { loginUser } from "../../actions/authActions";
// import Logo from '../assets/softcryliclogo.png';
import Logo from '../assets/Sclogo.svg';

import './SignIn.css';
import classnames from "classnames";

class SignIn extends Component {
    constructor() {
        super();
        this.state = {
            email: "",
            password: "",
            errors: {}
        };
    }

    componentDidMount() {
        // If logged in and user navigates to Login page, should redirect them to dashboard
        if (this.props.auth.isAuthenticated) {
            this.props.history.push("/");
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.auth.isAuthenticated) {
            this.props.history.push("/"); // push user to dashboard when they login
        }
        if (nextProps.errors) {
            this.setState({
                errors: nextProps.errors
            });
        }
    }

    onChange = e => {
        this.setState({ [e.target.id]: e.target.value });
    };
    
    onSubmit = e => {
        e.preventDefault();
        const userData = {
            email: this.state.email,
            password: this.state.password
        };
        this.props.loginUser(userData);
        console.log("---->",this.state.errors);
    };
    
    render() {
        const { errors } = this.state;
        return (
            <div className="loginContainer">
                <div className="loginFloat">
                    <div className="logoPanel">
                        <div className="logoContent">
                            <img src={Logo} alt="" />
                            <p>
                                Welcome to Softcrylic Product portal!
                            </p>
                        </div>
                    </div>
                    <div className="credPanel">
                        <div className="header">Log in</div>
                        <form noValidate onSubmit={this.onSubmit} className="form">
                            <div className="formGroup">
                                <label>Email address</label>
                                <input onChange={this.onChange}
                                    value={this.state.email}
                                    error={errors.email}
                                    placeholder="eg. address@website.com"
                                    id="email"
                                    type="email"
                                    className={classnames("", {
                                        invalid: errors.email || errors.emailnotfound
                                    })}
                                />
                                <div className="error">
                                    {errors.email}
                                    {errors.emailnotfound}
                                </div>
                            </div>
                            <div className="formGroup">
                                <label>Password</label>
                                <input
                                    onChange={this.onChange}
                                    value={this.state.password}
                                    error={errors.password}
                                    placeholder="**********"
                                    id="password"
                                    type="password"
                                    className={classnames("", {
                                        invalid: errors.password || errors.passwordincorrect
                                    })}
                                />
                                <div className="error">
                                    {errors.password}
                                    {errors.passwordincorrect}
                                </div>
                            </div>
                            <div className="btnLogin">
                                <input type="submit" value="LOG IN" />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
SignIn.propTypes = {
    loginUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});
export default connect(
    mapStateToProps,
    { loginUser }
)(SignIn);